import type { Auth0Client } from "@auth0/auth0-spa-js";

export async function getAuthorizationHeaders(
  authClient: Auth0Client,
): Promise<{ authorization: string }> {
  return {
    authorization: `Bearer ${await authClient.getTokenSilently()}`,
  };
}
